import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';

/** Window / document title brand base for the admin SPA. */
export const ADMIN_APP_DISPLAY_NAME = 'EURECA Admin';

/**
 * Human-readable PT-BR label per top-level route segment. Keys are the first
 * path segment of the pathname. A segment without an entry (or the root) falls
 * back to the bare brand title. Extend this map as admin routes land.
 */
const SECTION_LABELS: Record<string, string> = {
  testes: 'Testes',
};

function sectionLabelForPath(pathname: string): string | null {
  const segment = pathname.split('/').filter(Boolean)[0];
  if (!segment) return null;
  return SECTION_LABELS[segment] ?? null;
}

/**
 * Keeps `document.title` in sync with the current route on every navigation:
 * `"<section> · <App>"`, or just the app name on the root / unmapped paths.
 * Must be rendered inside the TanStack `RouterProvider`.
 */
export function useDocumentTitle(): void {
  const pathname = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    const label = sectionLabelForPath(pathname);
    document.title = label ? `${label} · ${ADMIN_APP_DISPLAY_NAME}` : ADMIN_APP_DISPLAY_NAME;
  }, [pathname]);
}
